/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'
export type DriverIconLinkEmployeeFragment = {
  __typename?: 'Employee'
  id: string
  firstName: string | null
  lastName: string | null
}

export const DriverIconLinkEmployeeFragmentDoc = gql`
    fragment DriverIconLinkEmployee on Employee {
  id
  firstName
  lastName
}
    `
